import BaseCadastro from "components/BaseCadastro";
import OrigemProduto from "model/administracao/cadastro/produto/OrigemProduto";
import Deposito from "model/suprimentos/Deposito";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import OrigemProdutoService from "service/administracao/cadastro/produto/OrigemProdutoService";
import "react-hook-form";
import {Controller, useForm} from "react-hook-form";
import { Label } from "components/input/Label";

const origemService = new OrigemProdutoService();

export default function OrigemProdutoCadastro() {

    const [queryParameters] = useSearchParams();

    const {control, clearErrors, setError, setFocus, register, formState: {errors}} = useForm();

    const [origem, setOrigem] = useState<OrigemProduto>(new OrigemProduto());
    const [titulo, setTitulo] = useState<string>('Origem');
    const [editando, setEditando] = useState<boolean>(false);
    const [depositos, setDepositos] = useState<Deposito[]>([]);

    const inputNomeRef = useRef<any>(null);

    useEffect(() => {
        if (!window.location.pathname.includes("cadastrar")) {
            setEditando(true);
        }
        origemService.depositos().then((data) => {
            setDepositos(data);
        }).catch((error) => {
            console.log(error);
        });
    },[])

    function validar() {

        if(!origem.codigo){
            setError("codigo", {type: "manual", message: "Código é Obrigatório"}, {shouldFocus: true})
            return false;
        }if (!origem.nome) {
            setError("nome", {type: "manual", message: "Nome é Obrigatório"}, {shouldFocus: true})
            return false;
        }
        return true;
    }

    const codigoKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            if (!origem.codigo) {
                origemService.proximoCodigo().then((data) => {
                    setOrigem({...origem, codigo: data});
                    setFocus("nome");
                    clearErrors("codigo")
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }

    return (

        <BaseCadastro model={origem} service={origemService} setModel={(value: OrigemProduto) => setOrigem(value)} novoCadastro getNewModel={() => new OrigemProduto()}
            validar={() => validar()} urlService="/origemProduto" pathCadastro="/origemProduto" tituloPagina={'Origem'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <InputText 
                        disabled={editando} 
                        className={errors.codigo ? "p-invalid" : ""}
                        onKeyDown={(e)=>codigoKeyDown(e)} 
                        required value={origem.codigo||""} 
                        style={{ width: '100%' }}
                        {...register("codigo", {
                            onChange: (e) => {
                                setOrigem({ ...origem, codigo: e.target.value })
                                clearErrors("codigo")
                            } 
                        })} 
                    />
                </div>
                {errors.codigo && errors.codigo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigo?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText 
                        required value={origem.nome}
                        className={errors.nome ? "p-invalid" : ""} 
                        style={{ width: '100%' }}
                        {...register("nome", {
                            onChange: (e) => {
                                setOrigem({ ...origem, nome: e.target.value })
                                clearErrors("nome")
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Depósito padrão</Label>
                <div className="col-sm-12">
                    <Dropdown value={origem.depositoPadrao}
                        onChange={(e) => setOrigem({ ...origem, depositoPadrao: e.target.value })} 
                        style={{ width: '100%' }} 
                        options={depositos}
                        optionLabel="nome"    
                    />
                </div>
            </div>


        </BaseCadastro>
    )
}
